export default [
  { value: '(UTC-12:00) Baker Island, Howland Island', name: '-1200' },
  { value: '(UTC-11:00) Niue, Jarvis Island', name: '-1100' },
  { value: '(UTC-10:00) Papeete, Honolulu', name: '-1000' },
  { value: '(UTC-09:30) Marquesas Islands', name: '-0930' },
  { value: '(UTC-09:00) Anchorage, Gambier Islands', name: '-0900' },
  { value: '(UTC-08:00) Pacific Time (US & Canada)', name: '-0800' },
  { value: '(UTC-07:00) Mountain Time (US & Canada)', name: '-0700' },
  { value: '(UTC-06:00) Central Time (US & Canada)', name: '-0600' },
  { value: '(UTC-05:00) Eastern Time (US & Canada)', name: '-0500' },
  { value: '(UTC-04:00) Atlantic Time (Canada)', name: '-0400' },
  { value: '(UTC-03:30) St. John\'s, Labrador', name: '-0330' },
  { value: '(UTC-03:00) Buenos Aires, Cayenne', name: '-0300' },
  { value: '(UTC-02:00) South Georgia', name: '-0200' },
  { value: '(UTC-01:00) Cape Verde', name: '-0100' },
  { value: '(UTC) Coordinated Universal Time', name: '+0000' },
  { value: '(UTC+01:00) Bratislava, Paris', name: '+0100' },
  { value: '(UTC+02:00) Beirut, Cairo, Damascus, E. Europe', name: '+0200' },
  { value: '(UTC+03:00) Baghdad, Minsk, Moscow', name: '+0300' },
  { value: '(UTC+03:30) Iran', name: '+0330' },
  { value: '(UTC+04:00) Baku, Tbilisi, Yerevan', name: '+0400' },
  { value: '(UTC+04:30) Afghanistan', name: '+0430' },
  { value: '(UTC+05:00) Islamabad, Tashkent', name: '+0500' },
  { value: '(UTC+05:30) India, Sri Lanka', name: '+0530' },
  { value: '(UTC+05:45) Nepal', name: '+0545' },
  { value: '(UTC+06:00) Dhaka, Ekaterinburg, Almaty, Omsk', name: '+0600' },
  { value: '(UTC+06:30) Yangon, Myanmar', name: '+0630' },
  { value: '(UTC+07:00) Bangkok, Novosibirsk', name: '+0700' },
  { value: '(UTC+08:00) Beijing, Singapore, Kuala Lumpur', name: '+0800' },
  { value: '(UTC+08:45) Eucla', name: '+0845' },
  { value: '(UTC+09:00) Seoul, Tokyo, Ambon, Yakutsk', name: '+0900' },
  { value: '(UTC+09:30) Adelaide, Broken Hill', name: '+0930' },
  { value: '(UTC+10:00) Port Moresby, Sydney, Vladivostok', name: '+1000' },
  { value: '(UTC+10:30) Lord Howe Island', name: '+1030' },
  { value: '(UTC+11:00) Noumea, Solomon Islands, Vanuatu', name: '+1100' },
  { value: '(UTC+12:00) Auckland, Suva, Kamchatka', name: '+1200' },
  { value: '(UTC+12:45) Chatham Islands', name: '+1245' },
  { value: '(UTC+13:00) Samoa, Tonga, Phoenix Islands', name: '+1300' },
  { value: '(UTC+14:00) Line Islands', name: '+1400' },
];



// WEBPACK FOOTER //
// ./src/models/TimezonesList.js